"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.throwErrorIfIsNotCondition = exports.setValueByFieldType = exports.parseByValueType = exports.getPositionText = exports.getActiveFlushingStep = void 0;
require("core-js/modules/es.regexp.to-string.js");
var _paulCorePackage = require("paul-core-package");
var _constants = require("./constants");
const {
  valueExist
} = _paulCorePackage.functions;

/**
 * Function that returns the translated text of the device position
 * @param displayNameId
 * @param position
 * @return {string|null}
 */
const getPositionText = _ref => {
  let {
    displayNameId,
    tVDefault: {
      position = {}
    } = {}
  } = _ref;
  const key = +(displayNameId === null || displayNameId === void 0 ? void 0 : displayNameId.toString().slice(-2));
  return position[key] || null;
};

/**
 * Function to convert number values into a numeric value,
 * as well as to check the min, max and numeric value limits
 * @param {Event} e
 * @return {number|*}
 */
exports.getPositionText = getPositionText;
const setValueByFieldType = e => {
  var _e$target;
  const {
    type,
    min,
    max
  } = ((_e$target = e.target) === null || _e$target === void 0 || (_e$target = _e$target.parentElement) === null || _e$target === void 0 ? void 0 : _e$target.dataset) || {};
  const {
    value
  } = e.target || {};
  if (type === 'number') {
    if (value.length === 0 || !isNaN(+value)) {
      if (min && +value < min) return min;
      if (max && +value > max) return max;
      return +value;
    }
    return +value.slice(0, -1);
  }
  return value;
};

/**
 * Function for determining actual flushing step
 * Can return Object or null - step not identified
 * @param cV - current value
 * @param prevCV - prev current value
 * @param duration - duration time
 *
 * @return {null|{step: number}|{process: string, step: number}} - step:
 *   -1 - error;
 *    0 - identify step;
 *    1 - start;
 *    2 - flushing.
 */
exports.setValueByFieldType = setValueByFieldType;
const getActiveFlushingStep = _ref2 => {
  let {
    cV,
    prevCV,
    duration
  } = _ref2;
  if (valueExist(cV) && valueExist(prevCV) && valueExist(duration)) {
    // console.log('step identify', cV, prevCV, +duration)
    if ((cV > prevCV || cV < 10 && prevCV < 10) && +duration > 0) {
      // console.log('step open')
      return {
        step: 2,
        process: _constants.flushProcess.open
      };
    }
    if (cV === prevCV && cV > 50 && prevCV > 50 && +duration > 0) {
      // console.log('step flush')
      return {
        step: 2,
        process: _constants.flushProcess.flush
      };
    }
    if ((cV < prevCV && cV > 10 || cV === prevCV && cV >= 50 && prevCV >= 50) && +duration === 0) {
      // console.log('step close')
      return {
        step: 2,
        process: _constants.flushProcess.close
      };
    }
    // if ((cV === prevCV && +duration === 0) || (cV > prevCV && +duration === 0)) {
    if (cV === prevCV && +duration === 0 || cV < prevCV && cV < 10 && +duration === 0) {
      // console.log('step start')
      return {
        step: 1
      };
    }
    // console.log('step exception')
    return {
      step: 0
    };
  }
  // console.log('step loading')
  return {
    step: 0
  };
};

/**
 * @todo: move to core parseByValueType
 * @param {string} value value always get like string
 * @param {"bool" | "int"} valueType
 * @return {string | boolean | number | float}
 */
exports.getActiveFlushingStep = getActiveFlushingStep;
const parseByValueType = (value, valueType) => {
  switch (valueType) {
    case "bool":
      return value === "true";
    case "int":
      return Number(value);
    case "float":
      return Number(value);
    default:
      return value;
  }
};
exports.parseByValueType = parseByValueType;
const throwErrorIfIsNotCondition = (condition, message) => {
  if (!condition) {
    throw new Error(message);
  }
};
exports.throwErrorIfIsNotCondition = throwErrorIfIsNotCondition;